@if (activeNaviSection(); as section) {
  <fcom-sidebar-nav
    [activeNavItem]="activeNaviItem()"
    [activeNavSection]="activeNaviSection()"
    [nested]="nested()"
    [title]="title()"
    [showTitle]="showTitle()"
    [topSpacing]="topSpacing()"
    [bottomSpacing]="bottomSpacing()"
    data-elastic-exclude
  ></fcom-sidebar-nav>
}
